import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./dropdown.less";

const Dropdown = (props) => {
    const {selected, className, items, handleChange } = props;
    let dropdownOptions = items.map((item) => <option key={item.val} value={item.val}>{item.displayText}</option>);

	return (
		<select value={selected} className={classnames(className, "dropdown")} onChange={handleChange}>
			{dropdownOptions}
		</select>
	);
};



Dropdown.propTypes = {
    selected: PropTypes.string,
    className: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.any).isRequired,
}

export default Dropdown;


// WEBPACK FOOTER //
// ./src/react/views/generic/Dropdown.jsx